import { CityStructure } from '@/core/Game/constants'

export enum StructureGroup {
  DynamicBuilding = 'DynamicBuilding',
  Transportation = 'Transportation',
}
export const STRUCTURE_GROUPS: Record<StructureGroup, CityStructure[]> = {
  [StructureGroup.DynamicBuilding]: [CityStructure.House],
  [StructureGroup.Transportation]: [CityStructure.Road],
}
export const STRUCTURE_GROUP_TO_LABEL: Record<StructureGroup, string> = {
  [StructureGroup.DynamicBuilding]: 'Dynamic Building',
  [StructureGroup.Transportation]: 'Transportation',
}
